import React from 'react';
import AdUnit, { useAds } from './AdUnit';

const DetailAdSlot = ({ className = '' }) => {
  const ads = useAds('detail', 5);
  if (!ads.length) return null;

  const day = Math.floor(Date.now() / 86400000);
  const ad = ads[day % ads.length];

  return (
    <aside className={`ad-detail-slot ${className}`.trim()}>
      <AdUnit ad={ad} variant="detail" />
    </aside>
  );
};

export default DetailAdSlot;
